import React from "react";
import {COLORS} from "../../../../../../Constants";
import Hole from "./Hole";
import Layer from "./Layer";
import LineElement from "./LineElement";
import {noopStopPropagation} from "../../../../../../utils/common/StopPropagation";
import {calcPrevGroove} from "../CanvasCalcPositions/calcPrevGroove";
import * as THREE from "three";
import {holeFaceOverlayRadiusMm} from "../../../../../../utils/processing/holeVisual";

const Detail = ({
                    reaOnly,
                    shape,
                    points,
                    holes,
                    sideHoles,
                    detailData,
                    selectedHole,
                    setSelectedHole,
                    hoveredHole,
                    setHoveredHole,
                    processingHandle,
                    addEdgeHandle,
                    texture,
                    prevInnerContour,
                    ...props
                }) => {

    return (
        <Layer layer={0}>
            {/* raycast disabled: fill sits in front of contour Lines and would steal edge clicks */}
            <mesh
                scale={props.scale}
                position={[props.position[0], props.position[1], props.position[2] - props.scale * 2]}
                raycast={() => null}
                onClick={!reaOnly && noopStopPropagation}>

                <extrudeGeometry args={[shape, {
                    bevelEnabled: false,
                }]}/>
                <meshBasicMaterial color={"#EAEBEA"} toneMapped={false}/>

                {prevInnerContour?.type === "groove" &&
                    ["TOP", "BOTTOM"].includes(prevInnerContour?.contour?.position) && calcPrevGroove(prevInnerContour?.contour).lines.map((el) => {
                        return <LineElement
                            key={el.id}
                            width={4}
                            points={[el.line[0], el.line[1]]}
                            color={COLORS[6][800]}
                            dashSize={0.05 / props.scale} gapSize={0.05 / props.scale}
                        />
                    })}

                {["TOP", "BOTTOM"].includes(prevInnerContour?.contour?.position) && prevInnerContour?.type === "round" &&
                    <LineElement
                        width={4}
                        points={new THREE.EllipseCurve(+prevInnerContour?.contour.x, +prevInnerContour?.contour.y, +prevInnerContour?.contour.radius, +prevInnerContour?.contour.radius, 2 * Math.PI, false, 0).getPoints(100)}
                        color={COLORS[6][800]}
                        dashSize={0.05 / props.scale} gapSize={0.05 / props.scale}
                    />
                }

                {holes?.map((el) => {
                        if (el?.center == null || el?.radius == null) {
                            return null;
                        }
                        const isThrough = el.depth === detailData.height
                        const onBottom = el?.contour?.position === "BOTTOM"
                        const border = isThrough ? "solid" : onBottom ? "dash" : "none"
                        const holeColor = isThrough
                            ? "#8FA3B8"
                            : onBottom
                                ? COLORS[6][600]
                                : COLORS[5][600]
                        const overlayRadius = holeFaceOverlayRadiusMm(
                            el.radius,
                            detailData.length,
                            detailData.width,
                        )

                        const data = {
                            id: el.id,
                            name: el.name,
                            x: el.center.x,
                            y: el.center.y,
                            z: props.scale * 4,
                            radius: overlayRadius,
                            color: holeColor,
                            border,
                            showFill: true,
                        }
                        return (
                            <Hole
                                reaOnly={reaOnly}
                                key={`${el.id}${el.name}`}
                                data={data}
                                processingHandle={processingHandle}
                                hoveredHole={hoveredHole}
                                selectedHole={selectedHole}
                                setSelectedHole={setSelectedHole}
                                setHoveredHole={setHoveredHole}
                                scale={props.scale}/>
                        )
                    }
                )
                }
            </mesh>
        </Layer>
    )
}
export default Detail
